import { render, staticRenderFns } from "./RealEstateEmploymentCoefficientEditModal.vue?vue&type=template&id=594544de&scoped=true&"
import script from "./RealEstateEmploymentCoefficientEditModal.vue?vue&type=script&lang=js&"
export * from "./RealEstateEmploymentCoefficientEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594544de",
  null
  
)

export default component.exports